var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return (_vm.actions.barreGauche && _vm.actions.barreGauche.length) ||
    (_vm.actions.barreDroite && _vm.actions.barreDroite.length)
    ? _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body flex-center-space-between" }, [
          _c(
            "div",
            { staticClass: "flex-start barre-actions-gauche" },
            _vm._l(_vm.actions.barreGauche, function(action) {
              return _c(
                "div",
                { key: action.label || action.icone },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn",
                      class: action.class ? action.class : "btn-primary",
                      attrs: {
                        hidden: action.hidden,
                        disabled: _vm.disabled || action.disabled
                      },
                      on: {
                        click: function($event) {
                          return _vm.appliquerAction(action.methode)
                        }
                      }
                    },
                    [
                      action.icone
                        ? _c("i", { class: action.icone })
                        : _vm._e(),
                      _vm._v(_vm._s(action.label))
                    ]
                  )
                ],
                1
              )
            }),
            0
          ),
          _c(
            "div",
            { staticClass: "flex-end barre-actions-droite" },
            _vm._l(_vm.actions.barreDroite, function(action) {
              return _c(
                "div",
                { key: action.label || action.icone },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn",
                      class: action.class ? action.class : "btn-primary",
                      attrs: {
                        hidden: action.hidden,
                        disabled: _vm.disabled || action.disabled
                      },
                      on: {
                        click: function($event) {
                          return _vm.appliquerAction(action.methode)
                        }
                      }
                    },
                    [_vm._v(_vm._s(action.label))]
                  )
                ],
                1
              )
            }),
            0
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }